export enum PatientAllergiesConstants {
  NOT_IMPLEMENTED = 'patientAllergies/NOT_IMPLEMENTED',
  SAVE_ALLERGIES = 'patientAllergies/SAVE_ALLERGIES',
  SET_RESPONSE = 'patientAllergies/SET_RESPONSE',
  RESET_STATE = 'patientAllergies/RESET_STATE',
  SET_IS_LOADING = 'patientAllergies/SET_IS_LOADING',
  SET_PATIENT_ALLERGIES = 'patientAllergies/SET_PATIENT_ALLERGIES',
  GET_PATIENT_ALLERGIES_OPTIONS = 'patientAllergies/GET_PATIENT_ALLERGIES_OPTIONS',
  DELETE_ALLERGY = 'patientAllergies/DELETE_ALLERGY',
}
